import React from 'react';

export const AutoSaveContext = React.createContext();
